import { IconChartBar } from "@tabler/icons-react";
import { createElement, lazy, Suspense } from "react";

import { CAPS } from "@/shell/roles";

import type { FeatureRoute, NavItem } from "../types";

const ReportsPage = lazy(() => import("./ReportsPage").then((m) => ({ default: m.ReportsPage })));
const page = (surface: "admin" | "portal") =>
  createElement(Suspense, { fallback: null }, createElement(ReportsPage, { surface }));

export const routes: FeatureRoute[] = [
  { path: "/admin/reports", roles: CAPS.admin.reports, element: page("admin") },
  { path: "/portal/reports", roles: CAPS.portal.reports, element: page("portal") },
];

export const nav: NavItem[] = [
  { label: "Reports", path: "/admin/reports", icon: IconChartBar, surface: "admin", roles: CAPS.admin.reports },
  { label: "Reports", path: "/portal/reports", icon: IconChartBar, surface: "portal", roles: CAPS.portal.reports },
];
